module.exports = __webpack_public_path__ + "static/media/sport-back-history.3dcbd036.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sport-back-history.svg
// module id = 480
// module chunks = 7